import { useQuery } from '@tanstack/react-query';
import {
  WEBSITE_ANALYTICS_GROUPED_LIST_LIMIT,
  WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS,
} from '../constants';
import { fetchWebsiteAnalyticsSources } from '../services/websiteAnalytics.api';
import type { WebsiteAnalyticsDays } from '../types';

export function useWebsiteAnalyticsSources(
  days: WebsiteAnalyticsDays,
  productSlug: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: [
      'website-analytics',
      'sources',
      days,
      productSlug ?? 'all',
      WEBSITE_ANALYTICS_GROUPED_LIST_LIMIT,
    ],
    queryFn: () => fetchWebsiteAnalyticsSources(days, productSlug),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
